module.exports = __webpack_public_path__ + "static/media/manovr-5.dcca0a79.jpg";